import { SearchFilter } from "../../common/components/functional/FilterSearchField/FilterSearchField";
import { GroupedTableColumn } from "../../common/components/functional/GroupedTable/GroupedTable";

// TODO: check widths on desktop view
export const INVOICE_COLUMNS: GroupedTableColumn[] = [
  {
    fieldName: "invoiceNumber",
    displayName: "number",
    width: "5%",
  },
  {
    fieldName: "originInfo",
    displayName: "type",
    width: "5%",
  },
  {
    fieldName: "invoiceDate",
    displayName: "date",
    width: "5%",
    disableTooltip: true,
  },
  {
    fieldName: "invoiceDueDate",
    displayName: "dueDate",
    width: "5%",
    disableTooltip: true,
  },
  {
    fieldName: "invoiceValueDate",
    displayName: "valueDate",
    width: "5%",
    disableTooltip: true,
  },
  {
    fieldName: "buyerName",
    displayName: "buyer",
    width: "15%",
  },
  {
    fieldName: "buyerCostCenterName",
    displayName: "billedCostCenter",
    width: "20%",
  },
  {
    fieldName: "vatExcludedAmount",
    displayName: "vatExcludedAmount",
    width: "5%",
  },
  {
    fieldName: "vatAmount",
    displayName: "vatAmount",
    width: "5%",
  },
  {
    fieldName: "vatIncludedAmount",
    displayName: "vatIncludedAmount",
    width: "5%",
  },
  {
    fieldName: "eezyCompanyName",
    displayName: "eezyCompanyName",
    width: "18%",
  },
  {
    fieldName: "",
    displayName: "status",
    width: "12%",
    flairComponent: true,
  },
];

export const INVOICE_TYPES = ["Internal", "External"];

// Values of the BillingType enum in the back end
export const INVOICE_BILLING_TYPES = [
  "SalaryHourly",
  "SalaryMonthly",
  "Manual",
];

export const INVOICE_DRAFT = "Draft";
export const INVOICE_EDITED = "Edited";
export const INVOICE_READY = "Ready";
export const INVOICE_SENT_PENDING = "SentPending";
export const INVOICE_SENT_SUCCESS = "SentSuccess";
export const INVOICE_SENT_FAILED = "SentFailed";

export const CREDIT_INVOICE = "CreditInvoice";

export const INVOICE_STATUS_TYPES = [
  INVOICE_DRAFT,
  INVOICE_EDITED,
  INVOICE_READY,
  INVOICE_SENT_PENDING,
  INVOICE_SENT_SUCCESS,
  INVOICE_SENT_FAILED,
];

export const INITIAL_INVOICE_FILTERS: SearchFilter[] = [
  { name: "invoiceTypes", value: "External" },
  { name: "invoiceDateFrom", value: "", type: "date" },
  { name: "invoiceDateTo", value: "", type: "date" },
  { name: "invoiceDueDateFrom", value: "", type: "date" },
  { name: "invoiceDueDateTo", value: "", type: "date" },
  { name: "invoiceValueDateFrom", value: "", type: "date" },
  { name: "invoiceValueDateTo", value: "", type: "date" },
  {
    name: "invoiceStatuses",
    value: INVOICE_STATUS_TYPES.filter((status) => status !== "Ready"),
  },
  { name: "customerOrganizationNames", value: "" },
  { name: "eezyCompanyNames", value: "" },
  { name: "salesPersonIds", value: "", displayValue: "" },
  { name: "invoiceWaves", value: "" },
  { name: "customerCC", value: "", displayValue: "" },
  { name: "billingTypes", value: [] },
];

export const INVOICE_WAVE_ONE = "Wave1";
export const INVOICE_WAVE_TWO = "Wave2";

export const ACCEPTED_ATTACHMENT_TYPES = [
  ".doc",
  ".xls",
  ".tif",
  ".jpg",
  ".jpeg",
  ".gif",
  ".txt",
  ".xml",
  ".htm",
  ".html",
  ".pdf",
];

export const CREDIT_INVOICE_REASONS = [
  "hoursIncorrect",
  "informationWrong",
  "other",
];

export const BANK_NAMES = [
  {
    bic: "NDEAFIHH",
    nameFi: "Nordea Pankki (Nordea)",
    nameEn: "Nordea Bank Finland PLC",
  },
  { bic: "HANDFIHH", nameFi: "Handelsbanken", nameEn: "Svenska Handelsbanken" },
  {
    bic: "ESSEFIHX",
    nameFi: "Skandinaviska Enskilda Banken (SEB)",
    nameEn: "Skandinaviska Enskilda Banken",
  },
  {
    bic: "DABAFIHH",
    nameFi: "Danske Bank A/S, Suomen sivuliike",
    nameEn: "Danske Bank A/S, Finland Branch",
  },
  { bic: "SBANFIHH", nameFi: "S-Pankki", nameEn: "S-Bank Ltd" },
  {
    bic: "DNBAFIHX",
    nameFi: "DNB Bank ASA, Finland Branch",
    nameEn: "DNB Nor Bank ASA, Filial Finland",
  },
  {
    bic: "SWEDFIHH",
    nameFi: "Swedbank",
    nameEn: "Swedbank (Foreningssparbanken AB) Filial Swedbank",
  },
  {
    bic: "ITELFIHH",
    nameFi:
      "Säästöpankkien Keskuspankki, Säästöpankit (Sp) ja Oma Säästöpankki",
    nameEn: "Savings Bank Finland",
  },
  { bic: "HELSFIHH", nameFi: "Aktia Pankki", nameEn: "Aktia Bank P.L.C." },
  {
    bic: "POPFFI22",
    nameFi: "POP Pankit (POP), Bonum Pankki",
    nameEn: "POP Bank",
  },
  { bic: "OKOYFIHH", nameFi: "OP Ryhmä", nameEn: "OP Corporate Bank PLC" },
  {
    bic: "AABAFI22",
    nameFi: "Ålandsbanken (ÅAB)",
    nameEn: "Bank of Aland PLC",
  },
  {
    bic: "CITIFIHX",
    nameFi: "Citibank",
    nameEn: "Citibank International PLC, Finland Branch",
  },
  { bic: "BIGKFIH1", nameFi: "Bigbank", nameEn: "Bigbank AS Finland Branch" },
  {
    bic: "VPAYFIH2",
    nameFi: "Viva Payment Services S.A., Suomen sivuliike",
    nameEn: "Viva Payment Services S.A., Finnish Branch",
  },
  { bic: "HOLVFIHH", nameFi: "Holvi", nameEn: "Holvi Payment Services Ltd" },
];

export enum VatCode {
  S = "S",
  E = "E",
  AE = "AE",
  G = "G",
  K = "K",
}

export const VAT_CODES_ARRAY = Object.values(VatCode);

export const VAT_PERCENTS = ["0", "10", "13.5", "14", "24", "25.5"];

// This mapping also exists in backend. If changes are made here, must sync with backend.
export enum VatFreeTextForVatCode {
  S = "",
  E = "Verovapaa terveydenhoitopalvelu AVL 34 §",
  AE = "Käännetty verovelvollisuus AVL 8c §",
  G = "ALV 0 %, veroton myynti EU:n ulkopuolelle",
  K = "ALV 0 % (Yhteisömyynti)",
}

export const CREDIT_INVOICE_COLOR = "rgba(255, 150, 0, 0.3)";

export enum InvoiceSubtype {
  CreditInvoice = "creditInvoice",
  NewRepairInvoice = "newRepairInvoice",
  SalesInvoice = "salesInvoice",
}

export const LOCAL_STORAGE_KEY = "invoiceAttachmentsInScan";
